import { useState, useEffect } from "react";
import EditorPage from "./EditorPage";
import {
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  CircularProgress,
  Alert,
  Button,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Chip,
  useMediaQuery,
  IconButton
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { httpRequest } from "../../../../ui-utils/api";
import { apiUrl, backendHosts } from "../../../../ui-utils/apiConfig";
import axios from "axios";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// Utility functions for fetching data
const fetchBlogs = async () => {
  try {

    const response = await axios.get(`${backendHosts.ADMIN}${apiUrl.getAllBlogs}`)
    // const response = await httpRequest({
    //   endPoint: `${backendHosts.ADMIN}${apiUrl.getAllBlogs}`,
    //   method: "get",
    //   instance: "instanceOne",
    // });
    return response.data?.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

const fetchTags = async () => {
  try {

    const response = await axios.get(`${backendHosts.ADMIN}${apiUrl.getAllTags}`)
    // const response = await httpRequest({
    //   endPoint: `${backendHosts.ADMIN}${apiUrl.getAllTags}`,
    //   method: "get",
    //   instance: "instanceOne",
    // });
    return {
      totalTags: response.data?.total_tags || 0,
      tags: response.data?.tags || [],
    };
  } catch (error) {
    throw new Error(error.message);
  }
};

const BlogsPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalLoading, setModalLoading] = useState(false);
  const [allTags, setAllTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [totalTags, setTotalTags] = useState("");
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const isMediumScreen = useMediaQuery("(max-width:1200px)");

  const loadData = async () => {
    try {
      const blogsData = await fetchBlogs();
      const tagsData = await fetchTags();

      setBlogs(blogsData);
      setTotalTags(tagsData.totalTags);
      setAllTags(tagsData.tags);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleBlogClick = async (blog) => {
    console.log(blog)
    setSelectedBlog({
      blog_id: blog.blog_id,
      blog_html: "",
      blog_thumbnail_big_screen: "",
      blog_thumbnail_small_screen: "",
      blog_title: "Loading...",
      tags: [],
    });
    setModalLoading(true);

    try {
      const response = await axios.get(`${backendHosts.ADMIN}${apiUrl.getABlog}${blog.id}`)
      // const response = await httpRequest({
      //   endPoint: `${backendHosts.ADMIN}${apiUrl.getABlog}${blog.id}`,
      //   method: "get",
      //   instance: "instanceOne",
      // });

      setSelectedBlog({
        ...response.data?.blog,
        blog_id:blog?.blog_id,
      });
    } catch (error) {
      setError(error.message);
    } finally {
      setModalLoading(false);
    }
  };

  const handleCreateBlog = () => {
    setSelectedBlog({
      blog_id: null,
      blog_html: "",
      blog_thumbnail_big_screen: null,
      blog_thumbnail_small_screen: null,
      blog_title: "",
      tags: [],
    });
  };

  const handleSaveBlog = async (updatedBlog) => {
    try {
      await loadData();
      setSelectedBlog(null);
    } catch (error) {
      setError(error.message);
    }
  };

  const handleDeleteBlog = async () => {
    try {
      await loadData();
      setSelectedBlog(null);
    } catch (error) {
      setError(error.message);
    }
  };

  const handleTagClick = (tagName) => {
    setSelectedTags((prevSelectedTags) =>
      prevSelectedTags.includes(tagName)
        ? prevSelectedTags.filter((t) => t !== tagName)
        : [...prevSelectedTags, tagName]
    );
  };

  const handleClose=()=>{
    setSelectedBlog(null);
  }

  const filteredBlogs =
    selectedTags.length > 0
      ? blogs.filter(
          (blog) =>
            blog.blog_tags &&
            selectedTags.every((tag) => blog.blog_tags.includes(tag))
        )
      : blogs;

  return (
    <Box sx={{ p: 4, mt: 5, height: "100vh",width:"100vw" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
        <Typography variant="h4" fontWeight="bold" sx={{ color: "white" }}>
          Blog Posts
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleCreateBlog}
        >
          Create New Blog
        </Button>
      </Box>

      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <CircularProgress />
        </Box>
      )}
      {error && <Alert severity="error">{error}</Alert>}

      <Box sx={{ mb: 3, color: "white" }}>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          Tags ({totalTags} total)
        </Typography>
        {allTags.map((tag) => (
          <Chip
            key={tag.tag_name}
            label={`${tag.tag_name} (${tag.blog_count || 0})`}
            onClick={() => handleTagClick(tag.tag_name)}
            sx={{
              mr: 1,
              mb: 1,
              bgcolor: selectedTags.includes(tag.tag_name) ? "white" : "gray",
              color: selectedTags.includes(tag.tag_name) ? "black" : "white",
              "&:hover": {
                bgcolor: selectedTags.includes(tag.tag_name)
                  ? "#f0f0f0"
                  : "#333",
              },
            }}
          />
        ))}
      </Box>

      <Grid container spacing={3}>
        {filteredBlogs.map((blog) => {
          const thumbnail = isSmallScreen
            ? blog.blog_thumbnail_small_screen
            : blog.blog_thumbnail_big_screen;

          return (
            <Grid item key={blog.blog_id} xs={12} sm={6} md={4}>
              <Card
                sx={{
                  cursor: "pointer",
                  transition: "transform 0.3s, box-shadow 0.3s",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                  },
                  borderRadius: "12px",
                  border: "1px solid #e0e0e0",
                  display: "flex",
                  flexDirection: "column",
                  height: () => {
                    if (isSmallScreen) return "415px";
                    if (isMediumScreen) return "360px";
                    return "420px";
                  },
                }}
                onClick={() => handleBlogClick(blog)}
              >
                <CardMedia
                  component="img"
                  image={thumbnail}
                  alt={blog.blog_title}
                  sx={{
                    objectFit: "cover",
                  }}
                />
                <CardContent sx={{ flexGrow: 1, padding: "16px" }}>
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {blog.blog_title?.substring(0, 100)}...
                  </Typography>
                  <Typography
                    sx={{
                      color: "#999999",
                      marginBottom: "15px",
                      fontSize: "14px",
                    }}
                  >
                    {blog.blog_description?.substring(0, 100)}...
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}
                  >
                    {blog.blog_tags &&
                      blog.blog_tags.map((tag, index) => (
                        <Chip key={index} label={tag} size="small" />
                      ))}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mt: 2,
                    }}
                  >
                    <Typography variant="caption" color="text.secondary">
                      {new Date(blog.created_at).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      By {blog.created_by}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      <Dialog
        open={selectedBlog !== null}
        onClose={() => setSelectedBlog(null)}
        fullWidth
        maxWidth="800px"
      >
        {/* <DialogTitle>
          {selectedBlog?.blog_id ? "Edit Blog" : "Create New Blog"}
        </DialogTitle> */}
        <DialogTitle>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            <Typography sx={{ color: '#000000', fontWeight: 'bold' }}>
              {selectedBlog?.blog_id ? "Edit Blog" : "Create New Blog"}
            </Typography>

            <IconButton onClick={handleClose} sx={{ color: '#CB2F3F' }}>
              <CloseRoundedIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {modalLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
              <CircularProgress />
            </Box>
          ) : (
            selectedBlog && (
              <EditorPage
                blog={selectedBlog}
                onDelete={handleDeleteBlog}
                onSave={handleSaveBlog}
                onClose={() => setSelectedBlog(null)}
              />
            )
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default BlogsPage;
